export const DEFAULT_EXPIRATION_DAYS = 365;

export const RECOMMENDED_SIZES_COOKIE_KEY =
  'tadarida.size_advisor.recommended_sizes.v1';

export const GENDER_COOKIE_KEY = 'Gender.gender';
export const PRODUCT_IMAGE_TYPE_COOKIE_KEY =
  'tadarida.preferredProductImageType:v1';
